import { RootState } from "app/store";
import { BaseRadioWrapperProps } from "../colourFiltersModels";
import Switch from "shared/components/Switch";
import { ZFilterPlugin } from "krpano";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { useCallback } from "react";
import { setFilters } from "features/krpano/details-slice";

interface RadioWrapperProps extends BaseRadioWrapperProps {
  property: Extract<
    keyof RootState["krpano"]["plugins"]["zfilter"],
    "maskelement"
  >;
}

export const RadioWrapper: React.FC<RadioWrapperProps> = ({
  property,
  trueState,
  falseState,
}) => {
  // Plugin, State, and Dispatch
  const plugin = window.krpano.plugin.getItem<ZFilterPlugin>("zfilter");
  const pluginNotLoaded = !plugin?.loaded;
  const value = useAppSelector(
    (state) => state.krpano.plugins.zfilter[property]
  );
  const dispatch = useAppDispatch();

  // Callbacks
  const handleToggle = useCallback(
    (newValue: boolean) => {
      const value = newValue ? trueState : falseState;
      dispatch(setFilters({ [property]: value }));
      // Set in krpano
      try {
        if (plugin) {
          plugin[property] =
            value as ZFilterPlugin[RadioWrapperProps["property"]];
        }
      } catch (error) {
        console.error("Error setting radio value in plugin:", error);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, pluginNotLoaded, property]
  );

  return (
    <Switch
      name={`${property}Toggle`}
      size="smallMedium"
      checked={value === trueState}
      onChange={handleToggle}
    />
  );
};
